import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { Observable, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokenService } from '../../services/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class InfoService {

  apiUrl = environment.API_URL;
  token: string = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJDT0RJR09fVVNVQVJJTyI6IjEwODgiLCJBUFBfSUQgKElOSUNJQUwpIjoiODZiZjlmYzYtNzhhZC00YTY1LTg5ZTgtOGM5MWY4ZWFjNDNkIiwiTE9HSU4iOiJBZG1pbmlzdHJhQUNUTyIsIklQQUREUkVTUyI6Ijo6MSIsIlVJUF9JRCI6ImI0ODlmNGYzLThkMmUtNDhjZS1iNzVhLTBkYzYxY2RiMTU4MiIsIkNDVE9LRU4iOiIiLCJBUFBfSUQiOiI4NmJmOWZjNi03OGFkLTRhNjUtODllOC04YzkxZjhlYWM0M2QiLCJQQVJBTV9MT0dJTiI6Ilt7XCJpZFwiOjUzNzIsXCJ0aXBvXCI6XCJDb2RDbGllbnRlXCIsXCJjaGF2ZVwiOlwiTW9kZWxvIC0gQ2lkYWRlIEludGVsaWdlbnRlXCIsXCJ2YWxvclwiOlwiMjIxXCJ9XSIsIkZVTkNBTyI6WyJfMTEtNiIsIl8xLTUiLCJfMTAtNSIsIl8xMS01IiwiXzEyLTUiLCJfMTQtNSIsIl8yLTUiLCJfMy01IiwiXzQtNSIsIl81LTUiLCJfNi01IiwiXzctNSIsIl84LTUiLCJfOS01IiwiMTAtMTUiLCIxMDAtMSIsIjEwMS0xNSIsIjExLTE1IiwiMTEzLTE1IiwiMTE5LTEiLCIxMi0xNSIsIjEyMC0xNSIsIjEyMS0xIiwiMTMtMTUiLCIxMzEtMTUiLCIxMzMtMTUiLCIxNC0xNSIsIjE2LTE1IiwiMTgtMSIsIjE5LTEiLCIyMC0xIiwiMjEtMSIsIjIyLTEiLCIyMy0xNSIsIjI2LTEiLCIyNy0xIiwiMjktMSIsIjQzLTEiLCI0NC0xIiwiNDctMSIsIjQ4LTEiLCI0OS0xIiwiNS0xNSIsIjUwLTEiLCI1My0xIiwiNTQtMSIsIjU1LTEiLCI1Ny0xIiwiNTgtMSIsIjYtMTUiLCI2MC0xNSIsIjY0LTE1IiwiNjYtMSIsIjY3LTEiLCI2OS0xMyIsIjctMTUiLCI3MC0xNSIsIjcxLTEiLCI3Ni0xIiwiNzktMSIsIjgtMTUiLCI4MS0xIiwiODItMSIsIjgzLTEiLCI4NC0xIiwiODUtMSIsIjg3LTE1IiwiOS0xNSIsIjkwLTE1IiwiOTEtMSJdLCJuYmYiOjE3MjgwNzE5NzUsImV4cCI6MTg4NTc1MjAzNSwiaWF0IjoxNzI4MDcyMDM1LCJpc3MiOiJodHRwOi8vd3d3LmNvZGVjaXBoZXJzLmNvbSIsImF1ZCI6Imh0dHA6Ly93d3cuY29kZWNpcGhlcnMuY29tIn0.-wT0AHmdPAZMuUW-capxumf52hzEtKtnVBDBnZzB_jM'

  constructor(
    private http: HttpClient,
    private tokenService: TokenService
  ) { }

  getInfos(): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.token}`
    });

    return this.http.get(
      `${this.apiUrl}/api/EntidadeNegocio/ObterPorUsuario?ativo=1&filtro=SCS`,
      { headers }
    );
  }
}
